import { styled } from 'baseui'
import { Button } from 'baseui/button'
import { FlexColumn } from '@/shared/theme/styled-components'

export const Stack = styled(FlexColumn, {
  gap: '0.75rem',
})

export const ActionsRow = styled('div', {
  marginTop: '0.75rem',
})

export const ModeRow = styled('div', {
  marginBottom: '0.75rem',
})

export const ProvidersRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '10rem 10rem 1fr',
  gap: '0.75rem',
  alignItems: 'end',
  width: '100%',
})

export const FixedSelectWrap = styled('div', {
  minWidth: 0,
})

export const FullWidthButton = styled(Button, {
  width: '100%',
})

export const NotificationsWrapper = styled(FlexColumn, {
  marginTop: '0.75rem',
  gap: '0.5rem',
})

